import { NotifyUseCaseInterface } from 'application/usecases/NotifyUseCase';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import { PageTitle } from 'presentation/components/PageTitle';
import { ItemComponent } from './components/ItemComponent';

interface props {
    userUseCase: UserUseCaseInterface;
    notifyUseCase: NotifyUseCaseInterface;
}

const CU06501Page = ({ userUseCase, notifyUseCase }: props) => {
    return (
        <div className="CU-065-01-container h-full w-full">
            <PageTitle title="通知設定" />
            <section className="center-inside h-full w-full">
                <div className="center-item h-auto w-full md:w-full">
                    <ItemComponent userUseCase={userUseCase} notifyUseCase={notifyUseCase} />
                </div>
            </section>
        </div>
    );
};

export default CU06501Page;
